// Navigation service to abstract window.location usage
// This makes testing much easier since we can mock a simple module
// instead of fighting with jsdom's window.location restrictions

const navigationService = {
  // Navigate to a new URL
  navigateTo(url) {
    window.location.assign(url);
  },

  // Get the current pathname
  getPathname() {
    return window.location.pathname;
  },

  // Get the current href
  getHref() {
    return window.location.href;
  },

  // Set href directly (same as assign but some code uses this pattern)
  setHref(url) {
    window.location.href = url;
  },

  // Reload the page
  reload() {
    window.location.reload();
  }
};

export default navigationService;